import dayjs from "dayjs";

/*
 * Vitals and sugars are two charts, not one.
 *
 * A vitals row carries `grbs` and `insulin` columns, and there is a separate
 * `grbs` list as well - "Add Record" on the vitals panel writes the former,
 * the sugar chart writes the latter. Sent as they arrive, a form's `vitals`
 * reads as though every vitals round also took a sugar, and a reading on the
 * GRBS chart never reaches the form at all.
 *
 * So the two are separated the same way on screen and in what is submitted:
 * `vitals` carries the vitals columns, `grbs` carries the sugars from both
 * sources.
 */
const hasGrbsReading = (row) =>
  [row?.grbs, row?.insulin].some(
    (value) => value !== undefined && value !== null && value !== ""
  );

const byNewestFirst = (a, b) =>
  dayjs(b?.action_time).valueOf() - dayjs(a?.action_time).valueOf();

/** Vitals rows with the sugar columns taken out. */
export const getVitalsRows = (data) => {
  if (!Array.isArray(data?.vitals)) return [];
  return data.vitals.map(({ grbs, insulin, ...rest }) => rest);
};

/**
 * Sugars from both the GRBS chart and the vitals rounds that recorded one,
 * newest first. The same reading can appear in both lists, so one entry per
 * moment is kept.
 */
export const getGrbsRows = (data) => {
  const rows = [
    ...(Array.isArray(data?.grbs) ? data.grbs : []),
    ...(Array.isArray(data?.vitals) ? data.vitals : []),
  ].filter(hasGrbsReading);

  const seen = new Set();
  return rows
    .filter((row) => {
      const key = `${row?.action_time}|${row?.grbs}|${row?.insulin}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .sort(byNewestFirst);
};
